// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Button from "@insite/mobius/Button";
import Modal from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import React, { FC, useState } from "react";
import { css } from "styled-components";

const StyleguideModals: FC = () => {
    const [openSmall, setOpenSmall] = useState(false);
    const [openMedium, setOpenMedium] = useState(false);
    const [openLarge, setOpenLarge] = useState(false);

    const wrapperCss = css`
        display: flex;
        gap: 10px;
        flex-flow: row wrap;
        flex: 1 0 100%;
    `;

    const content = (
        <Typography variant="p">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elementum maximus neque ut pretium. Fusce
            interdum scelerisque augue non mollis. Integer hendrerit libero non elit cursus, eget gravida lorem congue.
            Fusce tempus, nibh sed venenatis egestas, massa sapien luctus sem, id suscipit dolor dui sed purus. Etiam
            facilisis ullamcorper semper. Suspendisse eget quam ut tortor semper mattis. Sed risus ex, pretium a dolor
            in, ultrices placerat eros. Ut eget pretium nisi. Sed neque diam, lacinia viverra dictum ut, ultrices et
            magna. Sed congue ac quam vitae placerat. Curabitur vitae tincidunt dolor.
        </Typography>
    );

    return (
        <StyleguideSection title="Modals">
            <StyledWrapper css={wrapperCss}>
                <Button onClick={() => setOpenSmall(true)}>Small</Button>
                <Button onClick={() => setOpenMedium(true)}>Medium</Button>
                <Button onClick={() => setOpenLarge(true)}>Large</Button>
            </StyledWrapper>
            <Modal headline="Small" isOpen={openSmall} handleClose={() => setOpenSmall(false)} sizeVariant="small">
                {content}
            </Modal>
            <Modal headline="Medium" isOpen={openMedium} handleClose={() => setOpenMedium(false)} sizeVariant="medium">
                {content}
            </Modal>
            <Modal headline="Large" isOpen={openLarge} handleClose={() => setOpenLarge(false)} sizeVariant="large">
                {content}
            </Modal>
        </StyleguideSection>
    );
};

export default StyleguideModals;
